<template>
  <div>
    <div class="w-full md:w-1/2 px-5 min-h-full flex flex-grow">
      <div class="w-full bg-white shadow-lg rounded my-4">
        <div class="bg-green-700 px-4 py-2 rounded">
          <h4 class="text-xl text-green-100  font-medium">5. třída</h4>
        </div>
        <div class="px-4 py-4">
          <ul>
            <li class="text-2xl text-gray-800 font-bold"><a href="/Test_1.pdf" target="_blank">Test č. 1</a> & <a href="/Test_1_odpovedi.pdf" target="_blank">Odpovědi</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testy"
};
</script>

<style lang="scss" scoped></style>
